import { Header } from './Header';
import { Footer } from './Footer';

export const Layout = ({ children }) => {
  return (
    <div className="explorer-layout">
      <Header />
      <main className="explorer-main">
        {children}
      </main>
      <Footer />
    </div>
  );
};
